/**
 * This file was auto-generated by Fern from our API Definition.
 */

export class LangfuseAPITimeoutError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, LangfuseAPITimeoutError.prototype);
  }
}
